export const REDO_CHAT_WIDGET_URL =
  process.env.REDO_CHAT_WIDGET_URL || "http://localhost:3008";

export const REDO_RETURNS_APP_URL_LOCAL = "http://localhost:3002";

export const GORGIAS_CLIENT_ID = process.env.GORGIAS_CLIENT_ID;

export const REDO_API_URL = process.env.REDO_API_URL || "http://localhost:8888";

export const REDO_MERCHANT_APP_VERSION =
  process.env.REDO_MERCHANT_APP_VERSION || "_";

export const REDO_MERCHANT_SERVER_URL =
  process.env.REDO_MERCHANT_SERVER_URL || "http://localhost:8007";

export const SENTRY_DSN = process.env.SENTRY_DSN || "";

export const FACEBOOK_CLIENT_ID = process.env.FACEBOOK_CLIENT_ID;

export const FACEBOOK_USER_CONFIG_ID = process.env.FACEBOOK_USER_CONFIG_ID;

export const FACEBOOK_BUSINESS_CONFIG_ID =
  process.env.FACEBOOK_BUSINESS_CONFIG_ID;

export const INSTAGRAM_BUSINESS_CONFIG_ID =
  process.env.INSTAGRAM_BUSINESS_CONFIG_ID;

export const ATTENTIVE_CLIENT_ID = process.env.ATTENTIVE_CLIENT_ID;
export const CHATBOT_USER_ID = process.env.CHATBOT_USER_ID;
export const GMAIL_CLIENT_ID = process.env.GMAIL_CLIENT_ID;
export const OUTLOOK_CLIENT_ID = process.env.OUTLOOK_CLIENT_ID;
export const ANONYMOUS_USER_ID = process.env.ANONYMOUS_USER_ID;
export const ATTENTIVE_OUTBOUND_USER_ID =
  process.env.ATTENTIVE_OUTBOUND_USER_ID;

export const SHIPBOB_CLIENT_ID = process.env.SHIPBOB_CLIENT_ID || "";
export const SHIPBOB_INTEGRATION_NAME =
  process.env.SHIPBOB_INTEGRATION_NAME || "";
